import React from 'react';
import cx from 'classnames';

import {
  Border,
  Button,
  Icon,
  LoadingSpinner,
  Text,
} from 'spindl-shared-components';
import ColumnHeaders from '../../molecules/ColumnHeaders';
import UserRowList from '../../molecules/UserRowList';
import UserListHeader from '../../organisms/UserListHeader';

import styles from './UserAccountList.module.scss';
import usePresenter from './UserAccountList.presenter';
import getProps from './UserAccountList.props';
import { UserAccountListCombinedProps } from './types';
import UserPageBar from '../../molecules/UserPageBar';


const UserAccountList: React.FC<UserAccountListCombinedProps> = React.memo((props) => {
  const {
    state,
    className,
    classes,
    userListHeader,
    userPageBar,
    columnHeaders,
    userRowList,
    border,
    icon,
    title,
    instructions,
    button,
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`userAccountList${variantName}`];
  let componentView;
  const userListHeaderView = (
    <>
        <UserListHeader
          className={cx(styles.userListHeader, classes?.userListHeader)}
          {...internalProps.userListHeader}
          {...userListHeader} />
        <UserPageBar
          {...userPageBar}/>
        <ColumnHeaders 
          {...internalProps.columnHeaders}
          {...columnHeaders} />
    </>
  );

  switch (variantName) {
    case 'Default': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          {userListHeaderView}
          <UserRowList 
            {...internalProps.userRowList}
            {...userRowList} />
        </div>
      );
      break;
    }
    case 'Empty': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          {userListHeaderView}
          <div className={cx(styles.emptyStateContent, className)}>
            <Icon
                className={cx(styles.icon, className)}
                {...internalProps.icon}
                {...icon}/>
            <div className={cx(styles.content, className)}>
                <Text
                  className={cx(styles.title, className)}
                  {...internalProps.title}
                  {...title}/>
                <Text
                  className={cx(styles.instructions, className)}
                  {...internalProps.instructions}
                  {...instructions}/>
                <Button
                  className={cx(styles.button, className)}
                  {...internalProps.button}
                  {...button}/>
            </div>
          </div>
        </div>
      );
      break;
    }
    case 'NoResults': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          {userListHeaderView}
          <div className={cx(styles.emptyStateContent, className)}>
            <Icon
                className={cx(styles.icon, className)}
                {...internalProps.icon}
                {...icon}/>
            <div className={cx(styles.content, className)}>
                <Text
                  className={cx(styles.title, className)}
                  {...internalProps.title}
                  {...title}/>
                <Text
                  className={cx(styles.instructions, className)}
                  {...internalProps.instructions}
                  {...instructions}/>
            </div>
          </div>
        </div>
      );
      break;
    }
    case 'Loading': {
      componentView = (
        <div className={cx(currentStyle, styles.userAccountListDefault, className)}>
          {userListHeaderView}
          <LoadingSpinner 
            {...internalProps.loadingSpinner}
            isActive />
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
});

export default UserAccountList;
